import React from "react";
import LoginCard from "@/components/cards/LoginCard";
import styles from "./css/LoginPage.module.css";
import "../translations/i18n";
import { useTranslation } from "react-i18next";
import { langDirection } from "@/utils/languages";

export const LoginPage: React.FC = () => {
  const { t, i18n } = useTranslation("LoginPage");
  const direction = langDirection(i18n.language);

  return (
    <>
      <div className={styles.container}>
        <div className={styles.page}>
          <div className={styles.header}>
            <span className={`${styles.logoText} ${styles[direction]}`}>
              <b className={styles.senseText}>{t("weitz")}</b> {t("byKal")}
            </span>
          </div>
          <div className={styles.welcome}>
            <span className={`${styles.welcomeText} ${styles[direction]}`}>
              {t("title")}
            </span>
          </div>
          <div className={styles.text}>
            <p>{t("description")}</p>
          </div>
          <div className={styles.card}>
            <LoginCard />
          </div>
        </div>
      </div>
    </>
  );
};
